<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="mb-3">
					<label for="companies">Kierowca</label>
					<ng-select id="driver" name="driver" [(ngModel)]="filters.driver" [multiple]="true">
						<ng-option *ngFor="let driver of drivers" [value]="driver.id">{{ driver.name }} </ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="companies">Spółka</label>
					<ng-select
						id="companies"
						name="companies"
						[(ngModel)]="filters.companies"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of companies" [value]="item.id">{{ item.shortName }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="statuses">Status</label>
					<ng-select
						id="statuses"
						name="statuses"
						[(ngModel)]="filters.status"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of status" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="driverKinds">Typ kierowcy</label>
					<ng-select
						id="driverKinds"
						name="driverKinds"
						[(ngModel)]="filters.driverKinds"
						[multiple]="true"
						[closeOnSelect]="false"
					>
						<ng-option *ngFor="let item of driverKinds" [value]="item.id">{{ item.name }}</ng-option>
					</ng-select>
				</div>
				<div class="mb-3">
					<label for="dietKind">Typ diety</label>
					<select
						id="dietKind"
						name="dietKind"
						class="form-select form-control"
						[(ngModel)]="filters.dietKind"
					>
						<option value="">Wszystkie</option>
						<option *ngFor="let item of dietKinds" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
				<div class="mb-3">
					<label for="isLeftToPay">Pozostało do zapłaty</label>
					<select
						id="isLeftToPay"
						name="isLeftToPay"
						class="form-select form-control"
						[(ngModel)]="filters.isLeftToPay"
					>
						<option value="">Wszystkie</option>
						<option *ngFor="let item of yesno" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
				<div class="mb-3">
					<label for="isConfirm">Kierowca Zatwierdzony</label>
					<select
						id="isConfirm"
						name="isConfirm"
						class="form-select form-control"
						[(ngModel)]="filters.isConfirm"
					>
						<option value="">Wszystkie</option>
						<option *ngFor="let item of yesno" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="modal-footer">
				<div class="btn-group me-auto">
					<button type="button" class="btn btn-danger" (click)="filtersClear()">Wyczyść</button>
					<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
				</div>
				<div class="btn-group">
					<button type="button" class="btn btn-primary" (click)="filtersSave()">Pokaż</button>
					<button type="button" class="btn btn-secondary" (click)="filtersClose()">Anuluj</button>
				</div>
			</div>
		</div>
	</div>
</div>
